// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  width: 100%;
  aspect-ratio: 1/1;
  margin: 0 auto;
  background: no-repeat center center fixed;
  background-size: 100% 100%;
}

.backdrop {
  background-color: rgba(0, 0, 0, 0.3) !important;
  aspect-ratio: 1/1;
  padding: 5px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.backdrop p {
  text-align: center;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/pdf-item/pdf-item.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,yCAAA;EACA,0BAAA;AACF;;AAEA;EACE,+CAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AAAE;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;AAEJ","sourcesContent":["ion-card {\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  margin: 0 auto;\n  background: no-repeat center center fixed;\n  background-size: 100% 100%;\n}\n\n.backdrop {\n  background-color: rgba(0, 0, 0, 0.3) !important;\n  aspect-ratio: 1 / 1;\n  padding: 5px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  p {\n    text-align: center;\n    text-transform: uppercase;\n    font-weight: 600;\n    color: #fff;\n\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
